export const environment = {
  production: true,
  buildId: '3037231503020071',
  configFile: 'config.json',
};
